import { render, staticRenderFns } from "./TreeCard.vue?vue&type=template&id=5454943c"
import script from "./TreeCard.vue?vue&type=script&lang=js"
export * from "./TreeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports